export default "__VITE_ASSET__58ec33b0__"